<script>

import config from '../../common/genericPanelConf';
import GenericTreeTable from '@/components/generic/GenericTreeTable.vue';
import CommonService from '@/services/common'
import DataTable from 'primevue/datatable';
import GenericCustomMasterDataAutocompleteV2 from '@/components/generic/GenericCustomMasterDataAutocompleteV2.vue';

export default {
    props: ['category', 'name'],
    components: {
        GenericTreeTable,
        GenericCustomMasterDataAutocompleteV2
    },
    data(){
        return{
            configuration: null,
            cloneAggregationDialog: {
                visible: false,
                body: {
                    tipologiaAggregazioneFromID: null,
                    nome: '',
                    descrizione: ''
                }
            },
            productData: [],
            selectedProductData: [],
            selectedIdProductAggregation: null,
            selectedIdFamilyAggregation: null,
            loading: false,
            selectedNode: null,
            livelloAssociazioneFamiglia: 0,
            associatedList: []
        }
    },
    created(){
        this.configuration = config.getConfiguration(this.name);
        if(this.configuration){
            this.$store.dispatch('security/setNavbarTitle', this.configuration.title);
        }
    },
    mounted(){
      //api = 'stocchino-plan-registry/family-product-aggregation-association'  
    },
    methods: {
        onAdd(){
            let uri = `/${this.category}/${this.name}/0`;
            this.$router.push(uri);
        },
        openCloneAggregationClick(id){
            this.cloneAggregationDialog.body = {
                tipologiaAggregazioneFromID: id,
                nome: '',
                descrizione: ''
            }
            this.cloneAggregationDialog.visible = true;
        },
        cloneAggregation(){
            let cloneApi = `stocchino-plan-registry/aggregation-type-clone`;
            let body = {...this.cloneAggregationDialog.body}
            CommonService.createItem(cloneApi, body, response => {
                console.log(response)
            })
        },
        onProductAggregationSelected(item){
            this.associatedList = [];
            this.productData = [];
            this.selectedProductData = [];
            let filters = [
                {
                    operator: 'eq',
                    value: item.value,
                    property: 'IdAggregazione'
                },
                {
                    operator: 'eq',
                    value: 2,
                    property: 'Livello'
                }
            ]

            let p = {
                start: 0,
                limit: 10000,
                sort: null,
                filter: JSON.stringify(filters)
            }

            CommonService.loadGeneric('stocchino-plan-registry/family-aggregation', p, response => {
                if(response.success){
                    this.productData = response.data;
                }else{
                    this.productData = [];
                }

            });
        },
        onFamilyNodeSelected(node){
            this.selectedProductData = [];
            this.associatedList = [];
            this.selectedNode = null;
            if(node.livello == this.livelloAssociazioneFamiglia){
                this.selectedNode = node;
                this.loadFamilyNodes(node.id);
            }
        },
        loadFamilyNodes(id){
            this.selectedProductData = [];
            this.loading = true;

            
            let filters = [
                {
                    operator: 'eq',
                    value: id,
                    property: 'IdNodoFamigliaPrincipale'
                }
            ]

            let p = {
                start: 0,
                limit: 10000,
                sort: null,
                filter: JSON.stringify(filters)
            }

            CommonService.loadGeneric(`stocchino-plan-registry/family-aggregation-association`, p, response => {
                this.loading = false;
                if(response.success){
                    this.associatedList = response.data;
                    for(let i=0; i<this.productData.length; i++){
                        let found = this.associatedList.find(el => {
                            return el.idNodoFamigliaAssociata == this.productData[i].id
                        });
                        if(found != null){
                            this.productData[i].checked = true;
                            this.productData[i].associationId = found.id;
                        }else{
                            this.productData[i].checked = false;
                        }
                        this.selectedProductData.push(this.productData[i])
                    }
                }

            });
        },
        onFamilyAggregationSelected(familyAggregation){
            this.selectedIdFamilyAggregation = familyAggregation.value;
            this.livelloAssociazioneFamiglia = familyAggregation.extraData.livelloAssociazione;
        },
        changeAssociation(item){
            if(item.checked){
                let body = {
                  idNodoFamigliaPrincipale: this.selectedNode.id,
                  idNodoFamigliaAssociata: item.id
                };

                CommonService.createItem('stocchino-plan-registry/family-aggregation-association', body, response => {
                    if(response.success){
                        this.loadFamilyNodes(this.selectedNode.id);
                    }
                });
            }else{
                CommonService.deleteGeneric(`stocchino-plan-registry/family-aggregation-association/${item.associationId}`, response => {
                    if(response.success){
                        this.loadFamilyNodes(this.selectedNode.id);
                    }
                });
            }
        }
    },
    computed: {
        conf(){
            return config;
        },
        uiPermissions() {
            return this.$store.getters['security/uiPermissions'];
        }
    }
}
</script>



<template>
    <div class="grid" style="height: 80vh;">
        <div class="col-8">
            <GenericTreeTable :configuration="configuration" :category="category" :name="name" @on-open-clone-aggregation-click="openCloneAggregationClick"
                @on-node-select="onFamilyNodeSelected" @on-filter-selected="onFamilyAggregationSelected"/>
        </div> 
        <div class="col-4">
            <div class="card">
                <DataTable :value="selectedProductData" :loading="loading" sortField="checked" :sortOrder="-1">
                    <template #header>
                        <div class="grid">
                            <div class="col-12" v-if="configuration.filterApi">
                                <label>{{$t(configuration.filterLabel)}}</label>
                                <GenericCustomMasterDataAutocompleteV2
                                    :name="'familyAggregationFamily'"
                                    v-model="selectedIdProductAggregation"
                                    :changeFn="onProductAggregationSelected"
                                    :api="'stocchino-plan-registry/aggregation-type-combo?getAggregazioneProdotti=false'"/>
                            </div>
                        </div>
                    </template>
                    <Column field="checked" :header="$t('StocchinoPlanProductAggregation.checked')">
                        <template #body="{ data, field }">
                            <Checkbox :binary="true" v-model="data[field]" autofocus @change="changeAssociation(data)" :disabled="uiPermissions('StocchinoPlanFamilyAggregation.associationCheckBox').isHidden"/>
                        </template>
                    </Column>
                    <Column field="site" :header="$t('StocchinoPlanProductAggregation.site')"></Column>
                    <Column field="codice" :header="$t('StocchinoPlanProductAggregation.codice')"></Column>
                    <Column field="descrizione" :header="$t('StocchinoPlanProductAggregation.descrizione')"></Column>
                </DataTable>
            </div>
        </div>
    </div>
</template>